module.exports = __webpack_public_path__ + "img/p16_03.893c5431.png";